import React from 'react';
import { connect } from 'react-redux';
import FilterList from 'components/elements/common/filterlist/FilterList';
import { filterSavedSearches, setFilter } from 'store/actions/savedsearch';

const SavedSearchFilter = props => (
  <FilterList className={props.className} filterList={props.filterSavedSearches} display={props.display} placeholder="Find Saved Search" setFilter={props.setFilter} filter={props.filter}/>
);

const mapStateToProps = ({ savedsearch }) => ({
  display: !!savedsearch.savedSearches.length,
  filter: savedsearch.filter,
});

const mapDispatchToProps = {
  filterSavedSearches,
  setFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchFilter);
